import TtamAutoSaveEmptyCampaignDialog from './empty-campaign-dialog/index.vue';
import TtamAutoSaveExitCommonErrorDialog from './exit-common-error-dialog/index.vue';
import TtamAutoSaveExitReachLimitDialog from './exit-reach-limit-dialog/index.vue';
import TtamAutoSaveExitButton from './exit-button/index.vue';
import TtamAutoSaveStatus from './status/index.vue';
import TtamAutoSaveExitDialog from './exit-dialog/index.vue';
import * as hooks from './hooks';

export default {
  TtamAutoSaveEmptyCampaignDialog,
  TtamAutoSaveExitCommonErrorDialog,
  TtamAutoSaveExitReachLimitDialog,
  TtamAutoSaveExitButton,
  TtamAutoSaveStatus,
  TtamAutoSaveExitDialog,
  ...hooks,
};
